// extracted by mini-css-extract-plugin
module.exports = {"dialog":"FireflyToSDialog_dialog__T4yNQ","no-pointer-events":"FireflyToSDialog_no-pointer-events__iNTZF"};